import React, { useMemo } from "react";

/**
 * RevolvingBelt
 * - Lightweight, seamless horizontal loop
 * - items: array of objects (orders)
 * - labelKey: main text (e.g., "customer")
 * - subKey: right under main (e.g., "amount")
 * - rightKey: right aligned meta (e.g., "status")
 */
export default function RevolvingBelt({ items = [], labelKey, subKey, rightKey }) {
  const safeItems = Array.isArray(items) ? items : [];
  // duplicate for seamless loop
  const loop = useMemo(() => safeItems.concat(safeItems), [safeItems]);

  return (
    <div className="belt-viewport">
      <div className="belt-track">
        {loop.map((it, idx) => (
          <div key={(it.orderId || it[labelKey] || "item") + "-" + idx} className="belt-card">
            <div className="belt-title" title={it[labelKey] || "—"}>
              {truncate(it[labelKey] || "—", 26)}
            </div>
            
            <div className="belt-sub">{it[subKey] || "—"}</div>
            <div className="belt-right">{pretty(it[rightKey])}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function pretty(v) {
  if (!v) return "—";
  const s = String(v).replace(/_/g, " ");
  return s.charAt(0).toUpperCase() + s.slice(1);
}
function truncate(s, n) { return (s || "").length > n ? s.slice(0, n - 1) + "…" : s; }
